module.exports = __webpack_public_path__ + "static/media/emissor-b-5.6d9ad125.png";